import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

import ValidatingField from './validating_field';

class Selector extends ValidatingField {
  constructor(props) {
    super(props);

    if (this.props.options) {
      this.state.options = this.props.options;
    }

    if (this.props.placeholder) {
      this.state.placeholder = this.props.placeholder;
    }

    if (this.props.initiallyValid) {
      this.state.beenVisited = true;
      this.props.onValid(this.props.name);
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.options) {
      this.setState({options: newProps.options});
    }

    super.componentWillReceiveProps(newProps);
  }

  renderArrow({onMouseDown, isOpen}) {
    return <span className={'select-arrow ' + (isOpen ? 'select-arrow-up' : '') }></span>
  }

  newStateFromInput(selectedOption) {
    return {
      value: selectedOption ? selectedOption.value : ''
    };
  }

  renderInput() {
    return(
      <Select
        placeholder={ this.state.placeholder }
        name={ this.props.name }
        onChange={ this.handleChange }
        onBlur={ this.handleBlur }
        options={ this.state.options }
        value={ this.props.value }
        searchable={ true }
        arrowRenderer={ this.renderArrow }
        className={ this.state.shouldDisplayError ? 'errored-field' : '' }
        disabled={ this.props.disabled }
      />
    );
  }
}

Selector.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.node.isRequired,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  initiallyValid: PropTypes.bool,
};

export default Selector;
